import { Empty, Typography } from "antd"

import noContent from "./empty-page.svg"

const { Paragraph, Title } = Typography

type Props = {
  children?: JSX.Element
  paragraph?: JSX.Element | string
  title: string
}
export const NoContent = ({ children, paragraph, title }: Props) => {
  return (
    <Empty
      description={
        <div>
          <Title level={3}>{title}</Title>
          {typeof paragraph === "string" ? (
            <Paragraph>{paragraph}</Paragraph>
          ) : (
            paragraph
          )}
        </div>
      }
      image={noContent}
      style={{ margin: 64 }}
    >
      {children}
    </Empty>
  )
}
